import { NestedTableNodeTree, NodeTrees } from '../../types';
import { convertNestedTable } from './nestedTable';
import { convertNodeRecord } from './nodeTrees';

// Main entrypoint into creating the initial collapsed state
export const createInitialCollapsedState = (
  src?: NodeTrees | NestedTableNodeTree[],
  collapseByDefault = false,
): Record<string, boolean> => {
  return Array.isArray(src)
    ? convertNestedTable(src, '', collapseByDefault)
    : convertNodeRecord(src, '', collapseByDefault);
};
